<template lang="pug">
  div(:style="{'background-color': getAvlItem.ignition ? `#FFFFFF`: `#F4F4F4`}")
    .flextDriverItem(@click="onClick")
      image-thumbnail(:width='90', :height='60', :src="item.vehicle.thumbnail_id" :border="getAvlItem.ignition ? `3px solid green` : `3px solid #E5E5E5`")
      .driverInfo
        div
          .driverTitle(:class="getAvlItem.ignition ? 'black--text' : 'grey--text text--darken-1' ")
            | {{ item.vehicle.name }}
          .span.numberPlate.caption {{item.vehicle.number_plate}}
          .driverDesc.d-flex.flex-row(v-if="item.avl_record")
            .mr-2(v-if="item.contact" :class="getAvlItem.ignition ? 'black--text' : 'grey--text text--darken-1' ") {{item.contact.first_name}} {{item.contact.last_name}} &nbsp;&mdash;
            div(:class="getAvlItem.ignition ? 'black--text' : 'grey--text' ") {{getAvlItem.time | moment("h:mm a - dddd, Do MMM YYYY")}}
          .grey--text.caption.d-flex.flex-row(v-if="item.avl_record")
            div() {{getDirection}}
            .mx-4() &nbsp; &ndash; &nbsp;
            div(:class="getAvlItem.ignition ? 'primary--text' : 'greu--text' ") {{(getAvlItem.odometer/1000).toFixed(3)}} Km


      .d-flex.flex-column.align-center(v-if="item.avl_record")
        .title(:class="getAvlItem.ignition ? 'primary--text': 'grey--text text--lighten-1'") {{getAvlItem.speed}}
        .caption(:class="getAvlItem.ignition ? 'black--text' : 'grey--text text--darken-1' ") Kph


        v-icon.iconLaunch(@click="onClickOpenRightMenu()") launch

    v-divider


</template>

<script>
import ImageThumbnail from "@/modules/global/components/forms/ImageThumbnail";

export default {
  components: {
    ImageThumbnail
  },

  props: {
    item: Object,
    status: String
  },
  data: () => ({}),
  methods: {
    getIconStyle: function() {
      let obj = {'color':'primary'};
      return obj;
    },
    onClickOpenRightMenu: function() {
      console.log("open right menu")
      this.$store.commit("showRightDrawer",{title:this.item.vehicle.name,id:this.item.vehicle.id,width:500,component:"RightMapWindow"})
    },
    onClick: function () {
      if (this.$store.mapTrip != null) {
        this.$store.mapTrip.flyTo({
          center: [this.getAvlItem.location.lon, this.getAvlItem.location.lat],
          essential: true,
          zoom:16,
        })
      }

      this.$store.commit("tracks/setCurrentIndexByVehicleID", this.item.vehicle.id);
      if(this.$store.state.right_drawer){
        this.$store.commit("showRightDrawer",{title:this.item.vehicle.name,id:this.item.vehicle.id,width:500,component:"RightMapWindow"})
      }

    }
  },
  computed: {
    getAvlInfo: function () {
      if (this.$store.getters["trios/getCurrentTrack"] != null)
        return this.$store.getters["tracks/getCurrentTrack"].avl_record;
      else
        return this.item.avl_record;
    },

    getAvlItem: function () {
      return this.item.avl_record;
    },

    getDirection: function () {
      let direction = "";

      if (this.getAvlItem) {
        let angle = this.getAvlItem.angle;
        if (angle > 360) {
          angle = angle % 360;
        }

        if (angle < 22.5) {
          direction = "North";
        } else if (angle > 22.5 && angle <= 67.5) {
          direction = "North East";
        } else if (angle > 67.5 && angle < 111.5) {
          direction = "East";
        } else if (angle >= 111.5 && angle <= 157) {
          direction = "South East";
        } else if (angle > 157 && angle < 202.5) {
          direction = "South";
        } else if (angle >= 202.5 && angle <= 247.5) {
          direction = "South West";
        } else if (angle > 247.5 && angle < 292.5) {
          direction = "West";
        } else if (angle >= 292.5 && angle <= 337.5) {
          direction = "North West";
        } else if (angle > 337.5) {
          direction = "North";
        }

        return direction;
      } else {
        return direction;
      }
    }
  }
};
</script>

<style scoped>
.flextDriverItem {
  display: flex;
  flex-direction: row;
  padding: 8px 15px 15px 15px;
}

.flextDriverItem:hover {
  cursor: pointer;
  background-color: #E0E0E0;
}

.driverInfo {
  padding-left: 12px;
  padding-right: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.driverTitle {
  font-size: 13px;
  font-weight: Bold;
}

.driverDesc {
  font-size: 12px;
}

.driverDirection {
  font-size: 12px;
  font-weight: lighter;
}

.status {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.statusIcon {
  margin-top: -2px;
  margin-left: 1px;
  font-size: 130%;
}

.numberPlate {
  font-weight: lighter;
}

.iconLaunch {
  color: #CCCCCC;
}
.iconLaunch:hover {
  color: #ec037b;
}

.vehicleThumbnailOn{
  border: 2px solid green;
  height: 60px;
  color: #e5e5e5
}
</style>
